import React, { useState, createContext, useContext } from 'react';
export type Language = 'en' | 'es' | 'he';
interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string) => string;
}
const translations: Record<Language, Record<string, string>> = {
  en: {
    'hero.title1': 'Your Private Hair',
    'hero.title2': 'Studio Experience',
    'hero.location': '5th Floor · 1720 Harrison St · Hollywood, FL',
    'hero.tagline': 'Premium color, extensions & styling in an exclusive, private setting.',
    'hero.bookBtn': 'Book Your VIP Appointment',
    'hero.viewServicesBtn': 'View Services & Pricing',
    'services.title': 'Services & Pricing',
    'services.subtitle': 'Premium hair services tailored to your unique style',
    'services.bookBtn': 'Book Your Appointment',
    'services.cat.hairCuts': 'Hair Cuts',
    'services.item.women': 'Women',
    'services.item.men': 'Men',
    'services.cat.styling': 'Styling',
    'services.item.blowDryShort': 'Blow-Dry — Short',
    'services.item.blowDryMedium': 'Blow-Dry — Medium',
    'services.item.blowDryLong': 'Blow-Dry — Long',
    'services.item.flatCurlyIron': 'Flat / Curly Iron',
    'services.cat.highlights': 'Highlights',
    'services.item.fullFoilShort': 'Full Foil — Short',
    'services.item.fullFoilMedium': 'Full Foil — Medium',
    'services.item.fullFoilLong': 'Full Foil — Long',
    'services.item.partialFoil': 'Partial Foil',
    'services.cat.treatments': 'Treatments',
    'services.item.keratin': 'Keratin',
    'services.item.botox': 'Botox',
    'services.item.hydrate': 'Hydrate',
    'services.item.olaplex': 'Olaplex',
    'services.cat.color': 'Color',
    'services.item.colorRoots': 'Color Roots',
    'services.item.fullColorShort': 'Full Color — Short',
    'services.item.fullColorMedium': 'Full Color — Medium',
    'services.item.fullColorLong': 'Full Color — Long',
    'services.item.balayageColor': 'Balayage Color',
    'services.cat.hairExtensions': 'Hair Extensions',
    'services.item.fusionHair': 'Fusion Hair',
    'services.item.tapeHair': 'Tape Hair',
    'services.item.clipHair': 'Clip Hair',
    'services.item.volume': 'Volume',
    'gallery.title': 'Our Work',
    'gallery.subtitle': 'Real transformations from our private studio',
    'about.title': 'The Experience',
    'about.subtitle': 'Elevated. Exclusive. Yours.',
    'about.p1': 'No crowded salon floors. No waiting in line. Just you, your stylist, and a completely private experience designed around your vision.',
    'about.p2': 'Located exclusively on the 5th floor, Bella Beauty Couture offers a sanctuary away from the street-level noise. Here, premium hair artistry meets unparalleled privacy.',
    'cta.title': 'Ready for the VIP Treatment?',
    'cta.bookBtn': 'Book Now on WhatsApp',
    'cta.address': '1720 Harrison St, 5th Floor, Hollywood, FL',
    'cta.appointmentOnly': 'By Appointment Only',
    'footer.by': 'By Nikki Swissa',
    'footer.address': '1720 Harrison St, 5th Floor, Hollywood, FL',
    'footer.rights': 'All Rights Reserved.'
  },
  es: {
    'hero.title1': 'Tu Estudio Privado de',
    'hero.title2': 'Belleza Capilar',
    'hero.location': '5to Piso · 1720 Harrison St · Hollywood, FL',
    'hero.tagline': 'Color premium, extensiones y estilismo en un entorno exclusivo y privado.',
    'hero.bookBtn': 'Reserva Tu Cita VIP',
    'hero.viewServicesBtn': 'Ver Servicios y Precios',
    'services.title': 'Servicios y Precios',
    'services.subtitle': 'Servicios premium de cabello adaptados a tu estilo único',
    'services.bookBtn': 'Reserva Tu Cita',
    'services.cat.hairCuts': 'Cortes de Cabello',
    'services.item.women': 'Mujeres',
    'services.item.men': 'Hombres',
    'services.cat.styling': 'Estilismo',
    'services.item.blowDryShort': 'Secado — Corto',
    'services.item.blowDryMedium': 'Secado — Mediano',
    'services.item.blowDryLong': 'Secado — Largo',
    'services.item.flatCurlyIron': 'Plancha / Rizador',
    'services.cat.highlights': 'Mechas',
    'services.item.fullFoilShort': 'Papel Completo — Corto',
    'services.item.fullFoilMedium': 'Papel Completo — Mediano',
    'services.item.fullFoilLong': 'Papel Completo — Largo',
    'services.item.partialFoil': 'Papel Parcial',
    'services.cat.treatments': 'Tratamientos',
    'services.item.keratin': 'Keratina',
    'services.item.botox': 'Bótox',
    'services.item.hydrate': 'Hidratación',
    'services.item.olaplex': 'Olaplex',
    'services.cat.color': 'Color',
    'services.item.colorRoots': 'Raíces de Color',
    'services.item.fullColorShort': 'Color Completo — Corto',
    'services.item.fullColorMedium': 'Color Completo — Mediano',
    'services.item.fullColorLong': 'Color Completo — Largo',
    'services.item.balayageColor': 'Color Balayage',
    'services.cat.hairExtensions': 'Extensiones',
    'services.item.fusionHair': 'Cabello Fusión',
    'services.item.tapeHair': 'Cabello Tape',
    'services.item.clipHair': 'Cabello Clip',
    'services.item.volume': 'Volumen',
    'gallery.title': 'Nuestro Trabajo',
    'gallery.subtitle': 'Transformaciones reales de nuestro estudio privado',
    'about.title': 'La Experiencia',
    'about.subtitle': 'Elevada. Exclusiva. Tuya.',
    'about.p1': 'Sin salones abarrotados. Sin esperas. Solo tú, tu estilista y una experiencia completamente privada diseñada en torno a tu visión.',
    'about.p2': 'Ubicado exclusivamente en el 5to piso, Bella Beauty Couture ofrece un refugio lejos del ruido de la calle. Aquí, el arte capilar premium se encuentra con una privacidad incomparable.',
    'cta.title': '¿Lista para el Tratamiento VIP?',
    'cta.bookBtn': 'Reserva Ahora por WhatsApp',
    'cta.address': '1720 Harrison St, 5to Piso, Hollywood, FL',
    'cta.appointmentOnly': 'Solo con Cita Previa',
    'footer.by': 'Por Nikki Swissa',
    'footer.address': '1720 Harrison St, 5to Piso, Hollywood, FL',
    'footer.rights': 'Todos los Derechos Reservados.'
  },
  he: {
    'hero.title1': 'חוויית הסטודיו',
    'hero.title2': 'הפרטית שלך',
    'hero.location': 'קומה 5 · 1720 Harrison St · הוליווד, פלורידה',
    'hero.tagline': 'צבע פרימיום, תוספות ועיצוב שיער בסביבה אקסקלוסיבית ופרטית.',
    'hero.bookBtn': 'הזמיני תור VIP',
    'hero.viewServicesBtn': 'צפייה בשירותים ומחירים',
    'services.title': 'שירותים ומחירים',
    'services.subtitle': 'שירותי שיער פרימיום המותאמים לסגנון הייחודי שלך',
    'services.bookBtn': 'הזמיני תור',
    'services.cat.hairCuts': 'תספורות',
    'services.item.women': 'נשים',
    'services.item.men': 'גברים',
    'services.cat.styling': 'עיצוב שיער',
    'services.item.blowDryShort': 'פן — קצר',
    'services.item.blowDryMedium': 'פן — בינוני',
    'services.item.blowDryLong': 'פן — ארוך',
    'services.item.flatCurlyIron': 'מחליק / מסלסל',
    'services.cat.highlights': 'הבהרות',
    'services.item.fullFoilShort': 'פויל מלא — קצר',
    'services.item.fullFoilMedium': 'פויל מלא — בינוני',
    'services.item.fullFoilLong': 'פויל מלא — ארוך',
    'services.item.partialFoil': 'פויל חלקי',
    'services.cat.treatments': 'טיפולים',
    'services.item.keratin': 'קרטין',
    'services.item.botox': 'בוטוקס',
    'services.item.hydrate': 'לחות',
    'services.item.olaplex': 'אולפלקס',
    'services.cat.color': 'צבע',
    'services.item.colorRoots': 'צבע שורשים',
    'services.item.fullColorShort': 'צבע מלא — קצר',
    'services.item.fullColorMedium': 'צבע מלא — בינוני',
    'services.item.fullColorLong': 'צבע מלא — ארוך',
    'services.item.balayageColor': 'צבע בלאייז׳',
    'services.cat.hairExtensions': 'תוספות שיער',
    'services.item.fusionHair': 'שיער פיוז׳ן',
    'services.item.tapeHair': 'שיער טייפ',
    'services.item.clipHair': 'שיער קליפ',
    'services.item.volume': 'ווליום',
    'gallery.title': 'העבודות שלנו',
    'gallery.subtitle': 'שינויים אמיתיים מהסטודיו הפרטי שלנו',
    'about.title': 'החוויה',
    'about.subtitle': 'מרוממת. אקסקלוסיבית. שלך.',
    'about.p1': 'בלי רצפות סלון צפופות. בלי המתנה בתור. רק את, המעצבת שלך, וחוויה פרטית לחלוטין שעוצבה סביב החזון שלך.',
    'about.p2': 'ממוקם באופן בלעדי בקומה ה-5, Bella Beauty Couture מציע מקלט הרחק מרעש הרחוב. כאן, אמנות שיער פרימיום פוגשת פרטיות ללא תחרות.',
    'cta.title': 'מוכנה לטיפול ה-VIP?',
    'cta.bookBtn': 'הזמיני עכשיו בוואטסאפ',
    'cta.address': '1720 Harrison St, קומה 5, הוליווד, פלורידה',
    'cta.appointmentOnly': 'בתיאום מראש בלבד',
    'footer.by': 'ע״י ניקי סוויסה',
    'footer.address': '1720 Harrison St, קומה 5, הוליווד, פלורידה',
    'footer.rights': 'כל הזכויות שמורות.'
  }
};
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [language, setLanguage] = useState<Language>('en');
  const t = (key: string): string => {
    return translations[language][key] || key;
  };
  return <LanguageContext.Provider value={{
    language,
    setLanguage,
    t
  }} data-id="element-75">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}